<button [ngClass]="buttonclass" *ngIf="withbutton" (click)="openDialog()">
     <i [ngClass]="iconclass"></i>
     <div class="titol-raro" [ngClass]="titleclass">{{ resourcetitle | translate}}</div>
</button>

<span *ngIf="!withbutton" (click)="openDialog()" class="dialog"><i [ngClass]="iconclass"></i></span>